import { RolloverConstants } from './RolloverConstants';
import RolloverDetails from './steps/RolloverDetails/RolloverDetails';
import RolloverType from './steps/RolloverType/RolloverType';
import ReviewRollover from './steps/ReviewRollover/ReviewRollover';
import RolloverGuide from './steps/RolloverGuide/RolloverGuide';

export const listSteps = [
  {
    id: '1',
    stepValues: 1,
    component: <RolloverDetails />,
    label: RolloverConstants.rolloverDetailsPage.pageTitle,
    stepperLabel: RolloverConstants.rolloverDetailsPage.stepperLabel,
    showSecureLink: false,
    showBackLink: true,
    showWizard: true,
    card: {
      isActive: false,
    },
    faq: true,
    stepper: true,
  },
  {
    id: '2',
    stepValues: 2,
    component: <RolloverType />,
    label: RolloverConstants.rolloverTypePage.label,
    stepperLabel: RolloverConstants.rolloverTypePage.label,
    showSecureLink: false,
    showBackLink: true,
    showWizard: true,
    card: {
      isActive: false,
    },
    faq: true,
    stepper: true,
  },
  {
    id: '3',
    stepValues: 3,
    component: <ReviewRollover />,
    label: RolloverConstants.rolloverReviewPage.label,
    stepperLabel: RolloverConstants.rolloverReviewPage.label,
    showSecureLink: false,
    showBackLink: true,
    showWizard: false,
    card: {
      isActive: true,
      title: 'Summary',
      fundingMethodType: 'Employer Plan Rollover',
      btnLabel: RolloverConstants.rolloverReviewPage.btnLabel,
    },
    faq: false,
    stepper: true,
  },
  {
    id: '4',
    stepValues: 4,
    component: <RolloverGuide />,
    label: '',
    showSecureLink: false,
    showBackLink: false,
    showWizard: false,
    card: {
      isActive: true,
      headerImgUrl: RolloverConstants.rolloverGuidePage.headerImgUrl,
      title: 'Need Help?',
      subTitle: 'RolloverConcierge™',
      content: RolloverConstants.rolloverGuidePage.content,
      btnLabel: RolloverConstants.rolloverGuidePage.btnLabel,
      footerTitle: RolloverConstants.rolloverGuidePage.footerTitle,
    },
    faq: false,
    stepper: false,
  },
];
